/**
 * @file useTaskViewer.ts
 * @description Текущий сотрудник для правил задачи (phase19.31, crm.md T4):
 * id, владелец ли магазина (суперроль кабинета магазина) и право CRM.
 */

import { useAuth, useCurrentContext, useHasPermission } from "../../../auth/hooks";
import type { TaskViewer } from "./task-permissions";

export function useTaskViewer(): TaskViewer {
  const { me } = useAuth();
  const context = useCurrentContext();
  const canUseCrm = useHasPermission("SHOP_USE_CRM");
  return {
    userId: me?.user.id ?? null,
    isShopOwner: context?.role.isSuperrole === true && context.role.category === "SHOP",
    canUseCrm,
  };
}
